import React from 'react';

interface OutlineRightArrowProps {
    fill?: string;
}

export const OutlineRightArrow = ({ fill = 'currentColor' }: OutlineRightArrowProps) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_61_6423)">
            <path
                d="M9.03552 11.2929L4.09602 6.35343C4.00466 6.25842 3.95363 6.13174 3.95363 5.99993C3.95363 5.86812 4.00466 5.74144 4.09602 5.64643L9.03302 0.70993L8.32602 0.00293018L3.38902 4.93943C3.11651 5.22536 2.9645 5.60519 2.9645 6.00018C2.9645 6.39517 3.11651 6.775 3.38902 7.06093L8.32852 11.9999L9.03552 11.2929Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_61_6423">
                <rect width="12" height="12" fill="white" transform="translate(12) rotate(90)" />
            </clipPath>
        </defs>
    </svg>
);
